const BASE_URL = process.env.REACT_APP_API_CMS;
const WORDPRESS_URL = 'https://www.cf.coop.br/';

async function request(endpoint, method = 'GET', body = null) {
  const config = {
    method,
    headers: {
      'Content-Type': 'application/json'
    }
  };

  if (body && method !== 'GET') {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${BASE_URL}/api/${endpoint}`, config);
    if (!response.ok) throw new Error(`Erro ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error(`Erro na requisição [${method}] para ${endpoint}:`, error);
    throw error;
  }
}

async function requestWordpress(action, method = 'GET', body = null, params = {}) {
  const url = new URL(WORDPRESS_URL);
  
  // Para todos os métodos, adiciona o parâmetro eleicoes_api
  url.searchParams.append('eleicoes_api', action);
  
  // Para GET, adiciona outros parâmetros na URL
  if (method === 'GET') {
    Object.keys(params).forEach(key => {
      url.searchParams.append(key, params[key]);
    });
  }

  const config = {
    method,
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };

  // Adiciona o body para métodos POST, PUT, etc.
  if (body && method !== 'GET') {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url.toString(), config);
    if (!response.ok) throw new Error(`Erro ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error(`Erro na requisição [${method}] para ${action}:`, error);
    throw error;
  }
}

// Nova função para buscar notícias de eleições
export const getNoticias = () => requestWordpress('noticias');
export const getBoletins = () => requestWordpress('boletins');
export const getPaginas = () => request('paginas.php');
export const getFaq = () => request('faq.php');
export const getCandidatos = () => request('candidatos.php?idMateria=1');

// 🔗 Gera a URL do arquivo com base no identificador UUID
export const ObterURLArquivo = (identificador) => 
    `https://votacao-api.cf.coop.br/v1/arquivos/${identificador}`;

export const trackVisit = (trackingData) => {
  return requestWordpress('inserir_visita_eleicoes', 'POST', trackingData);
};

export const getVisitas = () => {
  return requestWordpress('visitas');
};

export const getConfiguracoes = () => {
  return request('configuracoes.php');
};

export const isBotaoInscricaoAtivo = async () => {
  try {
    const config = await getConfiguracoes();
    return config.botao_inscricao?.ativo ?? true;
  } catch (error) {
    console.error('Erro ao verificar botão de inscrição:', error);
    return true; // Default ativo se der erro
  }
};